import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import API from "../api";
import Branch from "components/Branch/Branch";
import { Link} from 'react-router-dom';
import Slider from "react-slick";
class Branches extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      flag: false,
      lockSubmit: false,
      branches: [],
    };
    this.validator = new SimpleReactValidator();
  }
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
    this.getBranches();
  }

  getBranches() {
    API({
      url: "getAllBranches",
      method: "GET",
    }).then((res) => {
      if (res.status && res.status === 200) {
        this.setState({ branches: res.data.branches });
      }
    });
  }

  render() {
    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>Our Branches | Branches for PTE & NAATI CCL Test Preparation</title>
          <meta name="description" content="12+ branches worldwide LA Language Academy delivering expert PTE and NAATI CCL coaching. Your success, proven results and support at every location." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/branches`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="Our Branches | Branches for PTE & NAATI CCL Test Preparation" />
          <meta name="twitter:description" content="12+ branches worldwide LA Language Academy delivering expert PTE and NAATI CCL coaching. Your success, proven results and support at every location." />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/branches`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Our Branches | Branches for PTE & NAATI CCL Test Preparation" />
          <meta property="og:description" content="12+ branches worldwide LA Language Academy delivering expert PTE and NAATI CCL coaching. Your success, proven results and support at every location." />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <Header />
          <div className="banner-section noc-banner">
            <div className="container">
              <div className="row">
                <div className="banner-content">
                  <h1 className="primary-heading dark-blue-color">
                    YOUR SUCCESS,
                    <br />
                    OUR GLOBAL REACH
                    <br className="d-block" />
                    <span className="wpl-badge pte-naati-badge text-white">
                      12+ LOCATIONS
                    </span> <br className="d-block d-md-none" /> <span className="fw-800">WORLDWIDE</span>
                  </h1>
                  <p className="sub-title">
                    Expert coaching, proven results, and personalized support <br className="d-none d-md-block" /> —delivered with the same excellence at every location.
                  </p>
                  <div className="iframe-video-outer position-relative">
                    <div className="banner-img-wrapper">
                      <img
                        className="banner-img"
                        src="/images/web-new-images/banners/branches-banner.png"
                        alt="LA"
                      />
                    </div>
                    <img
                      className="emoji1 position-absolute"
                      src="/images/web-new-images/emojis/emoji-1.png"
                      alt="LA"
                    />
                    <img
                      className="emoji2 position-absolute"
                      src="/images/web-new-images/emojis/emoji-2.png"
                      alt="LA"
                    />
                    <img
                      className="emoji3 position-absolute"
                      src="/images/web-new-images/emojis/emoji-3.png"
                      alt="LA"
                    />
                    <img
                      className="emoji4 position-absolute"
                      src="/images/web-new-images/emojis/emoji-4.png"
                      alt="LA"
                    />
                  </div>
                  <div className="light-blue-box">
                    Whether you're in Australia, India, or Nepal, access the same world-class training that has helped 50,000+ students achieve their English proficiency and immigration goals.
                  </div>
                  <button
                    className="primary-btn mt-2 border-0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                  >
                    FIND YOUR NEAREST LOCATION
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
             <div className="choice-ielts branch-global-excellence">
                <div className="container">
                  <div className="row">
                    <h2 className="primary-heading dark-blue-color text-center fw-700">
                      ONE STANDARD,
                      <br />
                      <span className="wpl-badge gold-badge text-white">
                         GLOBAL EXCELLENCE
                      </span>
                    </h2>
                    <p className="sub-sub-title fw-500 mb-4">No matter which Language Academy branch you visit, you'll receive</p>
                    <div className="plan-cards d-none d-md-flex">
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Identical Training Quality</h2>
                            <p>
                              Same proven methodologies <br className="d-none d-md-block" /> and expert instruction
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Consistent Results</h2>
                            <p>
                              95% success rate maintained <br className="d-none d-md-block" /> across all locations
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Updated Materials</h2>
                            <p>
                              Real-time access to latest <br className="d-none d-md-block" /> strategies and prediction files
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Local Expertise</h2>
                            <p>
                              Trainers who understand regional needs and challenges
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Flexible Options</h2>
                            <p>
                              Online support available even at physical locations
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                      <Slider {...CardsSlider} className="plan-cards">
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>Identical Training Quality</h2>
                              <p>
                                Same proven methodologies and expert instruction
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>Consistent Results</h2>
                              <p>
                                95% success rate maintained across all locations
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>Updated Materials</h2>
                              <p>
                                Real-time access to latest strategies and prediction files
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>Local Expertise</h2>
                              <p>
                               Trainers who understand regional needs and challenges
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="plan-card-outer">
                          <div className="plan-card">
                            <div className="icon-wrapper">
                              <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 1.49072L6 12.4907L1 7.49072"
                                  stroke="#48A75C"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                            <div className="content-wrapper">
                              <h2>Flexible Options</h2>
                              <p>
                                Online support available even at physical locations
                              </p>
                            </div>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <p className="sub-title fw-600">
                        Experience world-class coaching wherever you are.
                      </p>
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                      <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          BOOK YOUR FREE CONSULTATION
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>      
    
            <section className="branchesOuter">
              <div className="container">
                <div className="row">
                  <div className="branches-header text-center px-4">                  
                    <h2 className="primary-heading dark-blue-color text-center fw-500">
                        Hello. What can we help you with?
                        <br />
                        <span className="wpl-badge pte-naati-badge text-white">
                            Our Offices
                        </span>
                      </h2>               
                  </div> 
                  <div className="branches-second-row row">
                    {this.state.branches.map((branch) => {
                      return <Branch branch={branch.branch_detail} key={branch.id} />;
                    })}
                  </div>
                </div>
              </div>
            </section>

            <div className="master-aspect-section branch-global-reach">
              <div className="container">
                <div className="row">
                  <h2 className="primary-heading text-center fw-700">
                    ONLINE SUPPORT
                    <br />
                    <span className="wpl-badge text-white">
                      GLOBAL REACH
                    </span>
                  </h2>          

                  <div className="master-cards">
                    <div className="master-card">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0497 6.20117C15.0264 6.39174 15.924 6.86943 16.6277 7.57311C17.3314 8.27679 17.8091 9.17444 17.9997 10.1512M14.0497 2.20117C16.0789 2.42661 17.9713 3.33535 19.4159 4.77818C20.8606 6.22101 21.7717 8.11218 21.9997 10.1412M10.2266 14.0642C9.02506 12.8627 8.07627 11.504 7.38028 10.0544C7.32041 9.92971 7.29048 9.86737 7.26748 9.78848C7.18576 9.50812 7.24446 9.16386 7.41447 8.92643C7.46231 8.85962 7.51947 8.80246 7.63378 8.68815C7.98338 8.33855 8.15819 8.16374 8.27247 7.98797C8.70347 7.32507 8.70347 6.47049 8.27247 5.8076C8.15819 5.63183 7.98338 5.45702 7.63378 5.10742L7.43891 4.91255C6.90747 4.3811 6.64174 4.11538 6.35636 3.97104C5.7888 3.68397 5.11854 3.68397 4.55098 3.97104C4.2656 4.11538 3.99987 4.3811 3.46843 4.91255L3.3108 5.07018C2.78117 5.5998 2.51636 5.86462 2.31411 6.22465C2.08969 6.62415 1.92833 7.24465 1.9297 7.70287C1.93092 8.11581 2.01103 8.39804 2.17124 8.96248C3.03221 11.9959 4.65668 14.8582 7.04466 17.2462C9.43264 19.6342 12.295 21.2587 15.3284 22.1196C15.8928 22.2799 16.1751 22.36 16.588 22.3612C17.0462 22.3625 17.6667 22.2012 18.0662 21.9768C18.4263 21.7745 18.6911 21.5097 19.2207 20.9801L19.3783 20.8224C19.9098 20.291 20.1755 20.0253 20.3198 19.7399C20.6069 19.1723 20.6069 18.5021 20.3198 17.9345C20.1755 17.6491 19.9098 17.3834 19.3783 16.852L19.1835 16.6571C18.8339 16.3075 18.6591 16.1327 18.4833 16.0184C17.8204 15.5874 16.9658 15.5874 16.3029 16.0184C16.1271 16.1327 15.9523 16.3075 15.6027 16.6571C15.4884 16.7714 15.4313 16.8286 15.3644 16.8764C15.127 17.0464 14.7828 17.1051 14.5024 17.0234C14.4235 17.0004 14.3612 16.9705 14.2365 16.9106C12.7869 16.2146 11.4282 15.2658 10.2266 14.0642Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h2 className="card-title">24/7 ONLINE <br /> CLASSES AVAILABLE</h2>
                      <p className="sub-title fw-500">For students worldwide who can't access physical locations</p>
                      <ul>
                        <li>
                          <p className="fw-500"><span className="circle"></span> Australia-Based Online Support</p>
                          <a href="tel:61455566654">+61 455 566 654</a>
                        </li>
                        <li>
                          <p className="fw-500"><span className="circle"></span> India-Based Online Support</p>
                          <a href="tel:917652811912">+91 765 281 1912</a>
                        </li>
                        <li>
                          <p className="fw-500"><span className="circle"></span> Global Time Zone Coverage</p>
                          <h5>Classes available across all major time zones</h5>
                        </li>
                      </ul>
                    </div>
                    <div className="master-card card3">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2.4707V6.60124C14 7.1613 14 7.44132 14.109 7.65523C14.2049 7.8434 14.3578 7.99638 14.546 8.09225C14.7599 8.20124 15.0399 8.20124 15.6 8.20124H19.7305M16 13.2012H8M16 17.2012H8M10 9.20117H8M14 2.20117H8.8C7.11984 2.20117 6.27976 2.20117 5.63803 2.52815C5.07354 2.81577 4.6146 3.27471 4.32698 3.8392C4 4.48094 4 5.32101 4 7.00117V17.4012C4 19.0813 4 19.9214 4.32698 20.5631C4.6146 21.1276 5.07354 21.5866 5.63803 21.8742C6.27976 22.2012 7.11984 22.2012 8.8 22.2012H15.2C16.8802 22.2012 17.7202 22.2012 18.362 21.8742C18.9265 21.5866 19.3854 21.1276 19.673 20.5631C20 19.9214 20 19.0813 20 17.4012V8.20117L14 2.20117Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      </div>
                      <h2 className="card-title">
                        Online Features
                      </h2>
                      <ul>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Live Virtual Classrooms</strong> with expert trainers</p>
                        </li>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">AI-Powered Practice Platform</strong> accessible anywhere</p>
                        </li>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Real-Time Feedback</strong> and personalized coaching</p>
                        </li>                   
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Same Quality Guarantee</strong> as in-person classes</p>
                        </li>                   
                      </ul>
                    </div>
                  </div>             
                </div>
              </div>
            </div>
            <div className="master-aspect-section branch-global-reach branch-why-location">
              <div className="container">
                <div className="row">
                  <h2 className="primary-heading text-center fw-700">
                    WHY <br className="d-block d-md-none" /> <span className="wpl-badge gold-badge text-white">
                      LOCATION</span> <br className="d-block d-md-none" /> MATTERS
                  </h2>      

                  <div className="master-cards mt-4">
                    <div className="master-card">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0497 6.20117C15.0264 6.39174 15.924 6.86943 16.6277 7.57311C17.3314 8.27679 17.8091 9.17444 17.9997 10.1512M14.0497 2.20117C16.0789 2.42661 17.9713 3.33535 19.4159 4.77818C20.8606 6.22101 21.7717 8.11218 21.9997 10.1412M10.2266 14.0642C9.02506 12.8627 8.07627 11.504 7.38028 10.0544C7.32041 9.92971 7.29048 9.86737 7.26748 9.78848C7.18576 9.50812 7.24446 9.16386 7.41447 8.92643C7.46231 8.85962 7.51947 8.80246 7.63378 8.68815C7.98338 8.33855 8.15819 8.16374 8.27247 7.98797C8.70347 7.32507 8.70347 6.47049 8.27247 5.8076C8.15819 5.63183 7.98338 5.45702 7.63378 5.10742L7.43891 4.91255C6.90747 4.3811 6.64174 4.11538 6.35636 3.97104C5.7888 3.68397 5.11854 3.68397 4.55098 3.97104C4.2656 4.11538 3.99987 4.3811 3.46843 4.91255L3.3108 5.07018C2.78117 5.5998 2.51636 5.86462 2.31411 6.22465C2.08969 6.62415 1.92833 7.24465 1.9297 7.70287C1.93092 8.11581 2.01103 8.39804 2.17124 8.96248C3.03221 11.9959 4.65668 14.8582 7.04466 17.2462C9.43264 19.6342 12.295 21.2587 15.3284 22.1196C15.8928 22.2799 16.1751 22.36 16.588 22.3612C17.0462 22.3625 17.6667 22.2012 18.0662 21.9768C18.4263 21.7745 18.6911 21.5097 19.2207 20.9801L19.3783 20.8224C19.9098 20.291 20.1755 20.0253 20.3198 19.7399C20.6069 19.1723 20.6069 18.5021 20.3198 17.9345C20.1755 17.6491 19.9098 17.3834 19.3783 16.852L19.1835 16.6571C18.8339 16.3075 18.6591 16.1327 18.4833 16.0184C17.8204 15.5874 16.9658 15.5874 16.3029 16.0184C16.1271 16.1327 15.9523 16.3075 15.6027 16.6571C15.4884 16.7714 15.4313 16.8286 15.3644 16.8764C15.127 17.0464 14.7828 17.1051 14.5024 17.0234C14.4235 17.0004 14.3612 16.9705 14.2365 16.9106C12.7869 16.2146 11.4282 15.2658 10.2266 14.0642Z" stroke="#7F56D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h2 className="card-title">LOCAL EXPERTISE, GLOBAL STANDARDS</h2>
                      <p className="sub-title fw-500">Each branch offers</p>
                      <ul>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Cultural Understanding -</strong> Trainers who understand local student challenges</p>
                        </li>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Regional Immigration Knowledge -</strong> Specific visa and pathway expertise</p>
                        </li>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Language Support -</strong> Native language assistance where needed</p>
                        </li>
                        <li>
                          <p className="fw-400"><span className="circle"></span> <strong className="fw-600">Community Connections -</strong> Local success stories and networking</p>
                        </li>
                      </ul>
                    </div>
                    <div className="master-card card3">
                      <div className="img-wrapper">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 6.05859V12.0586L16 14.0586M22 12.0586C22 17.5814 17.5228 22.0586 12 22.0586C6.47715 22.0586 2 17.5814 2 12.0586C2 6.53575 6.47715 2.05859 12 2.05859C17.5228 2.05859 22 6.53575 22 12.0586Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h2 className="card-title">
                        PROVEN REGIONAL <br /> SUCCESS
                      </h2>
                      <ul>                        
                        <li>
                          <h4><span className="circle"></span> Australia</h4> 
                          <p className="fw-300">95% success rate for visa <br className="d-none d-md-block" /> and university applications</p>
                        </li>                  
                        <li>
                          <h4><span className="circle"></span> India</h4> 
                          <p className="fw-300">90% of students achieve target <br className="d-none d-md-block" /> scores within 6 weeks</p>
                        </li>                  
                        <li>
                          <h4><span className="circle"></span> Nepal</h4> 
                          <p className="fw-300">Leading destination for Australian <br className="d-none d-md-block" /> migration preparation</p>
                        </li>                  
                      </ul>
                    </div>
                  </div>  
                  <p className="sub-sub-title mt-4 mt-md-0 fw-600 text-center">Your location shouldn't limit your success, and with us, it won't.</p>           
                </div>
              </div>
            </div>
             <div className="naati-mobile-app branch-yourvisit">
              <div className="container">
                <div className="row">
                  <h2 className="primary-heading text-center fw-700">
                    Book
                    <br />
                    <span className="wpl-badge  text-white">YOUR VISIT</span>
                    <br />
                    Today
                  </h2>
                  <h2 className="sub-sub-title text-white fw-500 mt-0 mb-4">
                    Ready to experience the Language Academy difference in person?
                  </h2>
                  <h2 className="comprehensive-title text-white">
                    Choose your preferred location and book a free consultation
                  </h2>
                  <div className="plan-cards d-none d-md-flex">
                    <div className="plan-card-outer">
                      <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <p>
                        <strong className="fw-600">Free Assessment</strong> of your current proficiency level
                        </p>
                      </div>
                    </div>
                    </div>
                    <div className="plan-card-outer">                  
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <p>
                          <strong className="fw-600">Personalized Study Plan</strong> tailored to your goals
                        </p>
                      </div>
                    </div>
                    </div>
                    <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <p>
                          <strong className="fw-600">Centre Tour</strong> to see our facilities and technology
                        </p>
                      </div>
                    </div>
                    </div>
                      <div className="plan-card-outer">                   
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <p>
                          <strong className="fw-600">Meet Your Trainers</strong> and understand our methodology
                        </p>
                      </div>
                    </div>
                    </div>
                    <div className="plan-card-outer">
                    
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <p>
                          <strong className="fw-600">Flexible Scheduling</strong> options for your lifestyle
                        </p>
                      </div>
                    </div>
                    </div>
                  </div>

                  {/* Mobile HTML */}
                  <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                    <Slider {...CardsSlider} className="plan-cards">
                    <div className="plan-card-outer">
                        <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <p>
                          <strong className="fw-600">Free Assessment</strong> of your current proficiency level
                          </p>
                        </div>
                        </div>
                    </div>
                    <div className="plan-card-outer">                  
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <p>
                            <strong className="fw-600">Personalized Study Plan</strong> tailored to your goals
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <p>
                            <strong className="fw-600">Centre Tour</strong> to see our facilities and technology
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">                   
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <p>
                            <strong className="fw-600">Meet Your Trainers</strong> and understand our methodology
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">                    
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <p>
                            <strong className="fw-600">Flexible Scheduling</strong> options for your lifestyle
                          </p>
                        </div>
                      </div>
                    </div>
                    </Slider>
                  </div>

                </div>
                <div className="row align-items-center">
                    <div className="col-lg-7">
                      <p className="sub-title fw-500">
                        No matter which branch you choose, your success is our guarantee.
                      </p>
                    </div>
                    <div className="col-lg-5 text-center text-lg-end mt-4 mt-lg-0">
                      <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          BOOK YOUR FREE CONSULTATION
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
              </div>
            </div>
             <div className="why-choosing-section poc-why-choosing branch-our-locations pb-0">
                <div className="container">
                  <div className="row">
                    <h2 className="primary-heading text-center fw-700">
                      CONTACT <br />
                      <span className="wpl-badge pte-naati-badge text-white">
                        OUR LOCATIONS
                      </span>
                    </h2>
                    <div className="feature-cards four-cards d-none d-md-grid">
                      <div className="feature-card card2">                        
                        <h3><img
                            src="/images/web-new-images/flages/au-flag.png"
                            alt="Register Now"
                          /> AUSTRALIA ENQUIRIES</h3>
                        <ul>
                           <li>
                            <strong>Phone</strong>
                            <p><a href="tel:61426230061">+61 426 230 061</a></p>
                          </li>
                          <li>
                            <strong>Email</strong>
                            <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                          </li>
                          <li>
                            <strong>Address</strong>
                            <p>46 George Street, Parramatta NSW 2150</p>
                          </li>
                        </ul>
                      </div>
                      <div className="feature-card card1">
                        <h3><img
                            src="/images/web-new-images/flages/in-flag.png"
                            alt="Register Now"
                          />  INDIA ENQUIRIES</h3>
                        <ul>
                           <li>
                            <strong>Phone</strong>
                            <p><a href="tel:917652811911">+91 765 281 1911</a></p>
                          </li>
                          <li>
                            <strong>Email</strong>
                            <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                          </li>
                          <li>
                            <strong>Regional Contact</strong>
                            <p>Jalandhar Headquarters</p>
                          </li>                         
                        </ul>
                      </div>
                      <div className="feature-card card4">
                        <h3><img
                            src="/images/web-new-images/flages/ne-flag.png"
                            alt="Register Now"
                          /> NEPAL ENQUIRIES</h3>
                        <ul>
                           <li>
                            <strong>Phone</strong>
                            <p><a href="tel:97771591305">+977 71 591 305</a></p>
                          </li>
                          <li>
                            <strong>Email</strong>
                            <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                          </li>
                          <li>
                            <strong>Regional Contact</strong>
                            <p>Butwal Centre</p>
                          </li>                         
                        </ul>
                      </div>
                      <div className="feature-card card3">
                        <div className="rounded-circle">
                          <div className="img-wrapper">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.0497 6.81641C15.0264 7.00697 15.924 7.48466 16.6277 8.18834C17.3314 8.89202 17.8091 9.78967 17.9997 10.7664M14.0497 2.81641C16.0789 3.04184 17.9713 3.95058 19.4159 5.39341C20.8606 6.83625 21.7717 8.72742 21.9997 10.7564M10.2266 14.6795C9.02506 13.4779 8.07627 12.1193 7.38028 10.6696C7.32041 10.5449 7.29048 10.4826 7.26748 10.4037C7.18576 10.1234 7.24446 9.7791 7.41447 9.54167C7.46231 9.47486 7.51947 9.4177 7.63378 9.30339C7.98338 8.95378 8.15819 8.77898 8.27247 8.6032C8.70347 7.94031 8.70347 7.08573 8.27247 6.42284C8.15819 6.24706 7.98338 6.07226 7.63378 5.72265L7.43891 5.52778C6.90747 4.99634 6.64174 4.73062 6.35636 4.58627C5.7888 4.2992 5.11854 4.2992 4.55098 4.58627C4.2656 4.73062 3.99987 4.99634 3.46843 5.52778L3.3108 5.68542C2.78117 6.21504 2.51636 6.47985 2.31411 6.83988C2.08969 7.23939 1.92833 7.85988 1.9297 8.3181C1.93092 8.73105 2.01103 9.01327 2.17124 9.57772C3.03221 12.6111 4.65668 15.4735 7.04466 17.8615C9.43264 20.2494 12.295 21.8739 15.3284 22.7349C15.8928 22.8951 16.1751 22.9752 16.588 22.9764C17.0462 22.9778 17.6667 22.8164 18.0662 22.592C18.4263 22.3898 18.6911 22.1249 19.2207 21.5953L19.3783 21.4377C19.9098 20.9062 20.1755 20.6405 20.3198 20.3551C20.6069 19.7876 20.6069 19.1173 20.3198 18.5498C20.1755 18.2644 19.9098 17.9986 19.3783 17.4672L19.1835 17.2723C18.8339 16.9227 18.6591 16.7479 18.4833 16.6336C17.8204 16.2026 16.9658 16.2026 16.3029 16.6336C16.1271 16.7479 15.9523 16.9227 15.6027 17.2723C15.4884 17.3867 15.4313 17.4438 15.3644 17.4916C15.127 17.6617 14.7828 17.7204 14.5024 17.6386C14.4235 17.6156 14.3612 17.5857 14.2365 17.5258C12.7869 16.8298 11.4282 15.8811 10.2266 14.6795Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                         <h3>GLOBAL ONLINE SUPPORT</h3>
                        </div>
                        <ul>
                           <li>
                            <strong>Phone</strong>
                            <p><a href="tel:61455566654">+61 455 566 654</a></p>
                          </li>
                          <li>
                            <strong>Available</strong>
                            <p>24/7 across all time zones</p>
                          </li>                         
                        </ul>
                      </div>
                    </div>    
                    {/* Mobile HTML */}
                    <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                      <Slider {...CardsSlider} className="feature-cards four-cards">
                        <div className="feature-card card2">                        
                        <h3><img
                            src="/images/web-new-images/flages/au-flag.png"
                            alt="Register Now"
                          /> AUSTRALIA ENQUIRIES</h3>
                        <ul>
                           <li>
                            <strong>Phone</strong>
                            <p><a href="tel:61426230061">+61 426 230 061</a></p>
                          </li>
                          <li>
                            <strong>Email</strong>
                            <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                          </li>
                          <li>
                            <strong>Address</strong>
                            <p>46 George Street, Parramatta NSW 2150</p>
                          </li>
                        </ul>
                        </div>
                        <div className="feature-card card1">
                          <h3><img
                              src="/images/web-new-images/flages/in-flag.png"
                              alt="Register Now"
                            />  INDIA ENQUIRIES</h3>
                          <ul>
                            <li>
                              <strong>Phone</strong>
                              <p><a href="tel:917652811911">+91 765 281 1911</a></p>
                            </li>
                            <li>
                              <strong>Email</strong>
                              <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                            </li>
                            <li>
                              <strong>Regional Contact</strong>
                              <p>Jalandhar Headquarters</p>
                            </li>                         
                          </ul>
                        </div>
                        <div className="feature-card card4">
                          <h3><img
                              src="/images/web-new-images/flages/ne-flag.png"
                              alt="Register Now"
                            /> NEPAL ENQUIRIES</h3>
                          <ul>
                            <li>
                              <strong>Phone</strong>
                              <p><a href="tel:97771591305">+977 71 591 305</a></p>
                            </li>
                            <li>
                              <strong>Email</strong>
                              <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                            </li>
                            <li>
                              <strong>Regional Contact</strong>
                              <p>Butwal Centre</p>
                            </li>                         
                          </ul>
                        </div>
                        <div className="feature-card card3">
                          <div className="rounded-circle">
                            <div className="img-wrapper">
                              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.0497 6.81641C15.0264 7.00697 15.924 7.48466 16.6277 8.18834C17.3314 8.89202 17.8091 9.78967 17.9997 10.7664M14.0497 2.81641C16.0789 3.04184 17.9713 3.95058 19.4159 5.39341C20.8606 6.83625 21.7717 8.72742 21.9997 10.7564M10.2266 14.6795C9.02506 13.4779 8.07627 12.1193 7.38028 10.6696C7.32041 10.5449 7.29048 10.4826 7.26748 10.4037C7.18576 10.1234 7.24446 9.7791 7.41447 9.54167C7.46231 9.47486 7.51947 9.4177 7.63378 9.30339C7.98338 8.95378 8.15819 8.77898 8.27247 8.6032C8.70347 7.94031 8.70347 7.08573 8.27247 6.42284C8.15819 6.24706 7.98338 6.07226 7.63378 5.72265L7.43891 5.52778C6.90747 4.99634 6.64174 4.73062 6.35636 4.58627C5.7888 4.2992 5.11854 4.2992 4.55098 4.58627C4.2656 4.73062 3.99987 4.99634 3.46843 5.52778L3.3108 5.68542C2.78117 6.21504 2.51636 6.47985 2.31411 6.83988C2.08969 7.23939 1.92833 7.85988 1.9297 8.3181C1.93092 8.73105 2.01103 9.01327 2.17124 9.57772C3.03221 12.6111 4.65668 15.4735 7.04466 17.8615C9.43264 20.2494 12.295 21.8739 15.3284 22.7349C15.8928 22.8951 16.1751 22.9752 16.588 22.9764C17.0462 22.9778 17.6667 22.8164 18.0662 22.592C18.4263 22.3898 18.6911 22.1249 19.2207 21.5953L19.3783 21.4377C19.9098 20.9062 20.1755 20.6405 20.3198 20.3551C20.6069 19.7876 20.6069 19.1173 20.3198 18.5498C20.1755 18.2644 19.9098 17.9986 19.3783 17.4672L19.1835 17.2723C18.8339 16.9227 18.6591 16.7479 18.4833 16.6336C17.8204 16.2026 16.9658 16.2026 16.3029 16.6336C16.1271 16.7479 15.9523 16.9227 15.6027 17.2723C15.4884 17.3867 15.4313 17.4438 15.3644 17.4916C15.127 17.6617 14.7828 17.7204 14.5024 17.6386C14.4235 17.6156 14.3612 17.5857 14.2365 17.5258C12.7869 16.8298 11.4282 15.8811 10.2266 14.6795Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                          <h3>GLOBAL ONLINE SUPPORT</h3>
                          </div>
                          <ul>
                            <li>
                              <strong>Phone</strong>
                              <p><a href="tel:61455566654">+61 455 566 654</a></p>
                            </li>
                            <li>
                              <strong>Available</strong>
                              <p>24/7 across all time zones</p>
                            </li>                         
                          </ul>
                        </div>
                      </Slider>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-lg-7">
                      <p className="sub-title fw-400">
                        Your journey to success starts with choosing the right location. <br className="d-none d-lg-block" /> Every Language Academy branch is the right choice.
                      </p>
                    </div>
                    <div className="col-lg-5 text-center text-lg-end mt-4 mt-lg-0">
                      <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          FIND YOUR SUCCESS CENTRE TODAY
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
            </div>




        <Footer />
      </React.Fragment>
    );
  }
}
export default Branches;
